import { Typography } from '@mui/material'
import { useRecordContext } from 'react-admin'
import { NewsTitleProps } from './type'

export const NewsTitle: React.FC<NewsTitleProps> = ({ source, ...props }) => {
  const record = useRecordContext()
  return (
    <Typography variant='h3' {...props}>
      {record[source]}
    </Typography>
  )
}
